function Report() {
  return <div>Daily Report</div>;
}

export default Report;
